import api from './api';

/**
 * Meeting Service
 * Handles scheduling and managing meetings between investors, advisors, and analysts
 */
export const meetingService = {
  /**
   * Check if a time slot is available for a host
   * @param {Object} params - hostId, startTime, endTime
   */
  async checkAvailability(params) {
    const queryString = new URLSearchParams(params).toString();
    return api.get(`/meetings/check-availability?${queryString}`);
  },

  /**
   * Schedule a new meeting
   * @param {Object} meetingData - The meeting details
   */
  async scheduleMeeting(meetingData) {
    return api.post('/meetings/schedule', meetingData);
  },

  /**
   * Get all meetings for the current user
   */
  async getMyMeetings(userId,status,expired,expiryDateTime='') {
    return api.get(`/meetings/user/${userId}?status=${status}&expired=${expired}&expiryDateTime=${expiryDateTime}`);
  },

  /**
   * Get all meetings between users
   */
  async getMyMeetingsWithParticipant(userId,participantId,status,expired,expiryDateTime='') {
    return api.get(`/meetings/user/${userId}/participant/${participantId}?status=${status}&expired=${expired}&expiryDateTime=${expiryDateTime}`);
  },

  /**
   * Get all meetings for participant
   */
  async getMeetingsForParticipant(participantId,status,expired,expiryDateTime='') {
    return api.get(`/meetings/participant/${participantId}?status=${status}&expired=${expired}&expiryDateTime=${expiryDateTime}`);
  },

  /**
   * Update meeting status (accept/decline/cancel)
   * @param {string} meetingId - The ID of the meeting
   * @param {string} status - The new status
   */
  async updateMeetingStatus(meetingId, participantId, status) {
    return api.put(`/meetings/${meetingId}/status?participantId=${participantId}&status=${status}`);
  }
};

export default meetingService;
